import React, { Fragment } from "react";
import FeatherIcon from "feather-icons-react";
import * as style from "../styles.module.scss";
import {
  isRegistrationCompleted,
  isLegalComplianceCompleted,
  navigateToFirstNonCompletedStep,
  navigateToStepOne,
} from "../../../helpers/candidateJob";

const JobCard = ({
  clientName,
  jobDescription,
  onClick,
  btnClass,
  btnText,
  iconName,
  iconClass,
  completed,
  total,
}) => {
  return (
    <Fragment>
      <div className={`${style.profile__job_container} d-flex flex-column`}>
        <div className={`${style.profile__job_title} font-weight-bold`}>
          {clientName} - {jobDescription}
        </div>
        <div className={`${style.profile__job_icon} d-flex align-items-center`}>
          <FeatherIcon
            style={{ marginRight: "12px" }}
            icon={iconName}
            className={iconClass}
          />{" "}
          <span>
            {completed}/{total} sections completed
          </span>
        </div>
      </div>
      <div>
        <button
          className={`btn font-weight-bold px-2 ${btnClass} ${style.profile__job_button}`}
          onClick={onClick}
        >
          {btnText}
        </button>
      </div>
    </Fragment>
  );
};

const numberOfCompletedSteps = (appData, job) => {
  const step1Completed = isRegistrationCompleted(appData) ? 1 : 0;
  const step2Completed = isLegalComplianceCompleted(appData) ? 1 : 0;

  const sections = Object.values(job.sections);

  const completedSections = sections.filter((section) => section.completed);
  const dynamicSectionsCompleted = completedSections.length;

  const totalRequired = 2 + sections.length;
  const totalCompleted =
    step1Completed + step2Completed + dynamicSectionsCompleted;
  const isSectionCompleted = totalCompleted === totalRequired;

  return { totalCompleted, totalRequired, isSectionCompleted };
};

const CandidateJobSection = ({ appData, job }) => {
  const { totalCompleted, totalRequired, isSectionCompleted } =
    numberOfCompletedSteps(appData, job);
  return (
    <Fragment>
      {isSectionCompleted ? (
        <JobCard
          clientName={job.clientName}
          jobDescription={job.description}
          onClick={() => navigateToStepOne(job.id)}
          btnClass={"btn text-dark btn-outline-info"}
          btnText="View your job application"
          iconName={"check-circle"}
          iconClass={"text-success"}
          completed={totalCompleted}
          total={totalRequired}
        />
      ) : (
        <JobCard
          clientName={job.clientName}
          jobDescription={job.description}
          onClick={() => navigateToFirstNonCompletedStep(job.id, appData)}
          btnClass="btn btn-primary"
          btnText="Complete your job application"
          iconName="alert-circle"
          iconClass="text-danger"
          completed={totalCompleted}
          total={totalRequired}
        />
      )}
    </Fragment>
  );
};

export default CandidateJobSection;
